import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import 'react';
import { Input as Input$1, InputGroup, InputRightAddon } from '@hausgold/designsystem';
import { jsx } from '@emotion/react';
var _excluded = ["unit"];
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
var Input = function Input(_ref) {
  var unit = _ref.unit,
    props = _objectWithoutProperties(_ref, _excluded);
  return jsx(InputGroup, null, jsx(Input$1, _extends({
    bg: "gray.100",
    sx: {
      '&::placeholder': {
        color: 'gray.400'
      }
    }
  }, props)),
  // If a unit exists it shows it with the same style like the input has

  !!unit && jsx(InputRightAddon, {
    color: "gray.400",
    bg: "gray.100",
    fontSize: "lg",
    height: "3.75rem"
  }, unit));
};
Input.propTypes = _objectSpread({}, Input$1.propTypes);
export { Input as default };